module.exports = __webpack_public_path__ + "static/media/OSMB02.01d6faf4.jpg";